import * as ImmersiveReader from "@microsoft/immersive-reader-sdk";

window.ImmersiveReader = ImmersiveReader;
